var $ = require("jquery");
var Cookies = require("js-cookie");
const order = {
    //过滤覆盖原有元素
    fillOption: function (part, all) {
        $.each(part, function (k, v) {
            if (all[k]) part[k] = all[k];
        });
        return part;
    },
    //基本参数，不同的插件id不通的参数
    _option: {
        //下面是默认7000官网推荐的参数
        biz: "",
        _v: "", //v3会调用i_buy.cgi
        plug_id: 7000,
        appid: 1003,
        tradeType: 2, //1表示赠送，2表示iActionid=2
        needVip: 0,
        jifen_dikou: 0, //本次购买是否积分抵扣
        isOrderJifen: 0, //订单里面是否有积分抵扣
        iGameType: "", //游戏类型，用来进行角色
        iActionId: "", //活动id
        iActionType: "", //活动类型
        sActionNo: "", //活动No
        channel: 91003, //默认channel
        _from: "pc", //来源
        iSingleBuyLimit: "", //最大购买数量，为空时不显示数量选择
        paytype: 2, //下单时的支付方式 点券/钻石1，人民币2，金币3
        apptype: 4, //支付弹层，0：云支付，4：midas pc
        _t: new Date().getTime(),
    },
    _doCloudBuying: false,
    _doCloudPaying: false,
    _doCanceling: false,
    //业务逻辑参数
    _biz_option: {
        onPaySuccess: function () {
            alert("恭喜你购买成功！");
        },
        onPayCancel: null,
        onPaySend: null,
        onPayClose: null,
        onBuyError: null,
    },
    //初始化订单信息
    init: function (option) {
        this.fillOption(this._option, option);
        this.fillOption(this._biz_option, option);
        if (this._option._v == "v3") {
            this._option._app_id = this._option.appid;
            this._option._plug_id = this._option.plug_id;
            this._option._biz_code = this._option.biz;
        }
    },
    //add mask
    _showMask: function () {
        if ($("#dj_cloudpay_mask_2017").length == 0) {
            var _mask = "<div id='dj_cloudpay_mask_2017' style='position:fixed;top:0;bottom:0;right:0;left:0;opacity:0.5;filter:alpha(opacity=50);background-color:#000;z-index:3998;'></div>";
            $("body").append(_mask);
        } else {
            $("#dj_cloudpay_mask_2017").show();
        }
    },
    _hideMask: function () {
        $("#dj_cloudpay_mask_2017").hide();
    },
    //云支付唤起
    pay: function (option) {
        var $this = this;
        if ($this._doCloudPaying) {
            return false;
        }
        let Order = {
            _option: {}
        }
        Order._option.iPrice = option.amount;
        if (option._biz_code == "codo") {
            option._biz_code = "codol";
        }
        $this._doCloudPaying = true; //支付开启
        var _option = {
            _act_id: "",
            eventid: "",
            _biz_code: "",
            _app_id: Order._option._app_id && "1004" == Order._option._app_id ? "1004" : "1003",
            _output_fmt: "2",
            // _cs: "1",
            paytype: "1",
            apptype: 4,
            serial: "", //订单号
            acctype: option.acctype && option.acctype != "" ? option.acctype : "pt", //qq - 手Q授权登录态；wx – 微信授权登录态；默认为pt登录态
            openid: "", //openid-for微信
            access_token: "", //access_token-for微信
            appid: "", //appid-for微信
            skin: option.skin_black,
            url: window.location.protocol + "//apps.game.qq.com/daoju/igw/main/?_service=pay.midas.standard&_ret_key=result&_jsvar=i_pay&",
            onSuccess: function (opt) {},
            onCancel: function (opt) {},
            onSend: function (opt) {},
            onClose: function (opt) {},
        };
        //微信登录态处理
        if (Cookies.get("acctype") && Cookies.get("openid") && Cookies.get("access_token") && Cookies.get("appid")) {
            //openid登录，非msdk
            _option.acctype = Cookies.get("acctype");
            _option.openid = Cookies.get("openid");
            _option.access_token = Cookies.get("access_token");
            _option.appid = Cookies.get("appid");
            _option.paytype = 2;
        }
        _option = $.extend(_option, option);
        var payUrl = _option.url + "_act_id=" + _option._act_id + "&_biz_code=" + _option._biz_code + "&_app_id=" + _option._app_id + "&_output_fmt=" + _option._output_fmt + "&paytype=" + _option.paytype + "&apptype=" + _option.apptype + "&serial=" + _option.serial + "&acctype=" + _option.acctype + "&openid=" + _option.openid + "&access_token=" + _option.access_token + "&appid=" + _option.appid + "&r=" + Math.random();
        //前端的uin
        var temp_front_uin = (typeof(Cookies.get("uin"))  != undefined && Cookies.get("uin")!=null && Cookies.get("uin")!="") ? Cookies.get("uin").slice(1).replace(/\b(0+)/gi,"") : "";
        //唤起米大师
        var _callMidasPay = function () {
            $.getScript(payUrl, function () {
                if ("undefined" == typeof i_pay || null == i_pay) {
                    //返回异常
                    _option.onClose({
                        iRet: '-9999',
                        sMsg: '很抱歉，目前该活动的参与人数过多，请刷新页面再试哦！'
                    });
                    $this._hideMask();
                } else {
                    if (i_pay.result == 0) {
                        if (!i_pay.urlParams) {
                            if (!i_pay.payPrice || i_pay.payPrice != 0) {
                                _option.onClose({
                                    iRet: '-9999',
                                    sMsg: '关闭支付'
                                });
                            } else {
                                if (typeof $this._biz_option.onPaySuccess == "function") {
                                    $this._biz_option.onPaySuccess({
                                        iRet: '0',
                                        sMsg: '恭喜你购买成功！'
                                    });
                                }
                                return false;
                            }
                        }
                        var close_func = function () {
                            $this._hideMask();
                            _option.onClose();
                        };
                        var succ_func = function (opt) {
                            $this._hideMask();
                            _option.onSuccess(opt);
                        };
                        var cancel_func = function () {
                            $this._hideMask();
                            _option.onCancel();
                        };
                        $this._showMask();
                        var sUrl = i_pay.urlParams;
                        sUrl = sUrl.replace(/&amp;/g, "&");
                        midas.minipay.buyGoods(
                            {
                                title: "订单支付",
                                //hideHeader:1,
                                methods: {
                                    onResize: function () {},
                                    onSuccess: function () {
                                        $.getScript(window.location.protocol + "//apps.game.qq.com/daoju/v3/report/pay?iType=1&iAppId=1003&sBizCode=" + _option.biz + "&sSerialNum=" + _option.serial);
                                        _option.onSuccess({
                                            iRet: '0',
                                            sMsg: '支付成功！'
                                        });
                                    },
                                    onClose: function () {
                                        _option.onClose({
                                            iRet: '-9999',
                                            sMsg: '关闭支付'
                                        });
                                    }
                                }
                            },
                            {
                                appid: i_pay.offerId,
                                openid: _option.acctype == "wx" ? _option.openid : _option.acctype == "qc" ? i_pay.openid :temp_front_uin,
                                openkey: _option.acctype == "wx" ? _option.access_token : _option.acctype == "qc" ? i_pay.openkey : Cookies.get("skey"),
                                session_id: i_pay.payInfo.sessionid,
                                session_type: i_pay.payInfo.sessiontype,
                                sandbox: i_pay.sandbox == 1 ? 1 : 0,
                                pf: i_pay.pf,
                                goodstokenurl: i_pay.urlParams,
                                skin: _option.skin_black == 1 ? "lol" : "",
                            }
                        );
                    } else if (i_pay.result == -1074 || i_pay.result == -1076 || i_pay.result == -1075 || i_pay.result == -6561) {
                        _option.onClose({
                            iRet: i_pay.result,
                            sMsg: "对不起，请登录后再试"
                        });
                    } else {
                        _option.onClose({
                            iRet: i_pay.result,
                            sMsg: i_pay.msg
                        });
                    }
                    $this._hideMask();
                }
                $this._doCloudPaying = false;
            });
        };

        //启动
        $this._doCloudBuying = false;
        if (typeof midas == "undefined") {
            $.getScript(window.location.protocol + "//midas.gtimg.cn/midas/minipay_v2/jsapi/cashier.js", function () {
                _callMidasPay();
            });
        } else {
            _callMidasPay();
        }
    },
};

export function pcOrder() {
    return order
}
